import React from "react";
const SvgEditSrp = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      stroke="#39434E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M1 22.551l1.913-5.622L19.173 1 23 4.748 6.74 20.677 1 22.551zm15.304-18.74l3.826 3.748m-9.047 14.992H23"
    />
  </svg>
);
export default SvgEditSrp;
